import { pathBuilder } from 'config/paths/index';

export const root = '/admin/library';
export default pathBuilder(root);
